module.exports = __webpack_public_path__ + "media/images/classpoints/classpoints-hero_rowhouse-df1e72ef153ac9a151efe0a54e53ce7d.png";